import React from "react";
import { ShieldCheck, Target, Network } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useI18n } from "@/i18n";

const ICONS = [<ShieldCheck size={26} />, <Target size={26} />, <Network size={26} />];

export function WhyJetSeat() {
  const { t } = useI18n();
  const w = t.why;
  return (
    <section id="why" className="bg-background py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal>
          <p className="overline text-accent">{w.overline}</p>
          <h2 className="mt-4 font-serif text-4xl md:text-6xl tracking-tight leading-[1.02]">{w.title}</h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          {w.pillars.map((p, i) => (
            <Reveal key={i} delay={i * 0.1}>
              <div className="h-full border border-border p-8 bg-card" data-testid={`why-pillar-${i}`}>
                <span className="text-gold">{ICONS[i]}</span>
                <h3 className="mt-6 font-serif text-2xl md:text-3xl tracking-tight">{p.t}</h3>
                <p className="mt-4 text-muted-foreground text-base leading-relaxed">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
